import {Component, inject} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import {UvtService} from "../../services/uvt.service";

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrl: './results.component.scss'
})
export class ResultsComponent {
    title = 'Consulte si debe declarar renta';
    nit: boolean = false;
    numeroNit: string = '';
    numDocumento = '';
    name = '';
    declara = false;
    plazo = '';
    conditions = {
        ident1: false,
        ident2: false,
        ident3: false,
        ident4: false,
        ident5: false,
        ident6: false
    };
    private valorUvt!: any;

    private router = inject(Router);
    private browserTitle = inject(Title);
    private uvtService = inject(UvtService);

    constructor(){
        const vigencia = new Date().getFullYear()-1;
        this.browserTitle.setTitle(environment.tituloResultados+vigencia);
        let errors = false;
        const currentNavigation = this.router.getCurrentNavigation();
        console.log(currentNavigation?.extras)
        if(currentNavigation && currentNavigation.extras.state ) {
            const nit = currentNavigation.extras.state['nit'];
            const numeroNit = currentNavigation.extras.state['numeroNit'];
            const numDocumento = currentNavigation.extras.state['numDocumento'];
            const name = currentNavigation.extras.state['name'];
            const declara = currentNavigation.extras.state['declara'];
            const plazo = currentNavigation.extras.state['plazo'];
            const conditions = currentNavigation.extras.state['conditions'];

            if (conditions) {
                this.nit = nit === null || nit === undefined ? false : nit;
                this.numeroNit = numeroNit;
                this.numDocumento = numDocumento === null || numDocumento === undefined ? '' : numDocumento;
                this.name = name === null || name === undefined ? '' : name;
                this.declara = declara === null || declara === undefined ? false : declara;
                this.plazo = plazo === null || plazo === undefined ? '' : plazo;
                this.conditions = conditions;
                currentNavigation.extras.state = {};
            } else {
                console.error("Formato de datos incorrecto");
                errors = true
            }
        } else {
            console.error("No se recibieron datos");
            errors = true;
        }

        errors && this.navigateBack();
    }

    navigateBack(){
        this.router.navigate(["/"]);
    }

    handleChildError(){
        this.navigateBack();
    }


}
